<template>
  <main class="qa-validation">
    <h1>問答驗證</h1>

    <b-tabs @input="refreshTab">
      <b-tab title="準則庫" active>
        <QACriterionEditor ref="criterionEditor" />
      </b-tab>

      <b-tab title="AI 編碼">
        <QAAiRun ref="aiRun" />
      </b-tab>

      <b-tab title="人工編碼">
        <QACoder ref="coder" />
      </b-tab>

      <b-tab title="比較與校準">
        <QACompare
          ref="compare"
          @calibration-selected="calibrationContext = $event" />
        <template v-if="calibrationContext">
          <hr />
          <QACalibration :context="calibrationContext" />
        </template>
      </b-tab>

      <b-tab title="應用庫">
        <QAApplications ref="applications" />
      </b-tab>
    </b-tabs>
  </main>
</template>

<script>
import QACriterionEditor from "./QACriterionEditor.vue";
import QACoder from "./QACoder.vue";
import QAAiRun from "./QAAiRun.vue";
import QACompare from "./QACompare.vue";
import QACalibration from "./QACalibration.vue";
import QAApplications from "./QAApplications.vue";

export default {
  name: "QAValidation",
  data() {
    return { calibrationContext: null };
  },
  methods: {
    // 各分頁只在掛載時讀一次列表，切換分頁時重新讀取，才看得到其他分頁新增的資料
    refreshTab(index) {
      const refresh = [
        () => this.$refs.criterionEditor.loadCriteria(),
        () => this.$refs.aiRun.loadCriteria(),
        () => this.$refs.coder.loadCriteria(),
        () => this.$refs.compare.loadCriteria(),
        () => this.$refs.applications.loadApplications(),
      ][index];
      if (refresh) refresh();
    },
  },
  components: {
    QACriterionEditor,
    QACoder,
    QAAiRun,
    QACompare,
    QACalibration,
    QAApplications,
  },
};
</script>

<style scoped>
.qa-validation {
  padding: 24px;
}
</style>
